import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import InclinedRoadDiagram from "../../../../components/diagrams/InclinedRoadDiagram";
import FractionInput from "../../../../components/inputs/FractionInput"; // dodaj import na górze


function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Zadanie praktyczne: przewyższenie z nachylenia drogi
export function generateTask() {
  const angle = randomInt(5, 25);
  const c = [100, 120, 150, 170, 200, 220, 250][Math.floor(Math.random() * 4)];
  const radians = (angle * Math.PI) / 180;
  const height = Number((c * Math.sin(radians)).toFixed(2));

return {
  type: "InclinedRoadElevationTask",
  angle,
  c,
  height,
  data: { angle, c, height }, // ← opcjonalnie dodaj to, jeśli quiz tego oczekuje
};

}

export function renderTask({ angle, c, height }) {
  return (
    <div className="space-y-2"> {/* zmniejszono przerwę z 4 na 2 */}
      <p>
        Droga jest nachylona pod kątem <InlineMath math={`${angle}^\\circ`} inline /> i ma długość{" "}
        <InlineMath math={`${c}\\text{ m}`} inline />. Oblicz przewyższenie z dokładnością do <InlineMath math={`0,01 \\text{ m}`}/>.
      </p>
      <InclinedRoadDiagram angle={angle} length={c} elevation={height} />
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
<FractionInput
  value={userAnswer}
  onChange={onChange}
  disabled={disabled}
  label="h"
  suffixLatex="\text{m}"
/>
  );
}

export function renderAnswer({ height }) {
  const formatted = height.toFixed(2);
return <InlineMath math={`${formatted}\\ \\text{m}`} />;

}


export function checkAnswer(data, userAnswer) {
  const expected = data.height;

  const given = userAnswer?.parsed ?? Number(userAnswer);
  if (!isFinite(given)) return false;

  return Math.abs(given - expected) <= 0.02;
}




export function renderExplanation(input) {
  const data = input?.data ?? input;
  const { angle, c, height } = data;

  const approxSin = Math.sin((angle * Math.PI) / 180).toFixed(4);
  const rawHeight = (c * Math.sin((angle * Math.PI) / 180)).toFixed(4);
  const finalHeight = height.toFixed(2);

  return (
    <div className="space-y-4 text-left">
      <div>
        <strong>Krok 1:</strong> Korzystamy z definicji funkcji sinus:
        <BlockMath math={`\\sin(${angle}^\\circ) = \\frac{h}{${c}}`} />
      </div>

      <div>
        <strong>Krok 2:</strong> Przekształcamy wzór, by wyznaczyć <InlineMath math="h" />:
        <BlockMath math={`h = ${c} \\cdot \\sin(${angle}^\\circ)`} />
      </div>

      <div>
        <strong>Krok 3:</strong> Podstawiamy przybliżoną wartość funkcji sinus:
        <BlockMath math={`h \\approx ${c} \\cdot ${approxSin} = ${rawHeight}`} />
      </div>

      <div>
        <strong>Krok 4:</strong> Zaokrąglamy wynik do dwóch miejsc po przecinku:
        <BlockMath math={`h \\approx ${finalHeight}\\ \\text{m}`} />
      </div>
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  const formatted = userAnswer.raw
    .replaceAll("*", "\\cdot ")
    .replaceAll("/", "\\div ")
    .replaceAll("sqrt", "\\sqrt")
    .replaceAll("-", " - ")
    .replaceAll("+", " + ");

  return <InlineMath math={`${formatted}\\ \\text{m}`} />;
}
